import ExtensionLoaderService from '@peekops/peek-extensions-framework/services/extensions/extension-loader'

export default class CustomerFlowsExtensionLoaderService extends ExtensionLoaderService {
}
